import { useState, useEffect } from 'react';
import { Button, Table }  from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import api from '../utils/apiClient';

const formatName = (first_name, last_name) => {
    if (!first_name && !last_name) {
        return '';
    } else if (first_name && last_name) {
        return `${last_name}, ${first_name}`;
    }
    return first_name || last_name;
};

const TenantTable = ({ onEdit, onCreate }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    api.get('/tenants')
        .then(({ data }) => data.map((tenant) => {
            const tenant_admin = tenant.tenant_admin;

            tenant.admin_name = formatName(tenant_admin?.first_name, tenant_admin?.last_name);
            tenant.admin_email = tenant_admin?.email;
            tenant.admin_phone = tenant_admin?.phone;
            tenant.admin_username = tenant_admin?.username;
            return tenant;
        }))
        .then(setData)
        .catch((e) => { console.error(e); })
        .then(() => setLoading(false));
  }, []);

  const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        render: (_, record) => (
            <a onClick={() => onEdit(record)}>{record.name}</a>
        ),
    },
    { title: 'Admin Name', dataIndex: 'admin_name' },
    { title: 'Admin Email', dataIndex: 'admin_email' },
    { title: 'Admin Phone', dataIndex: 'admin_phone' },
    { title: 'Admin Username', dataIndex: 'admin_username' },
  ];

  return (
    <>
      <Button type="dashed" icon={<PlusOutlined />} onClick={onCreate} style={{ marginBottom: 16 }}>
        Add Tenant
      </Button>
      <Table rowKey="tenant_id" loading={loading} dataSource={data} columns={columns} />
    </>
  );
};

export default TenantTable;